export default __webpack_public_path__ + "static/media/Football_transparent.9f8f0867.png";